import React from "react";
import PropTypes from "prop-types";

export default function DoNotQuote({ doNotQuote }) {
  const className = doNotQuote ? "text-danger" : "text-success";

  return (
    doNotQuote && (
      <span className={className}>
        <i className="fa fa-check" />
        &nbsp;{doNotQuote ? "Yes" : "No"}
      </span>
    )
  );
}

DoNotQuote.propTypes = {
  doNotQuote: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/DoNotQuote.jsx